import { render, staticRenderFns } from "./RelatedPromos.vue?vue&type=template&id=4ff26a42"
import script from "./RelatedPromos.vue?vue&type=script&lang=js"
export * from "./RelatedPromos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2522521581/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff26a42')) {
      api.createRecord('4ff26a42', component.options)
    } else {
      api.reload('4ff26a42', component.options)
    }
    module.hot.accept("./RelatedPromos.vue?vue&type=template&id=4ff26a42", function () {
      api.rerender('4ff26a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/promotions/RelatedPromos.vue"
export default component.exports